import { useEffect, useState } from 'react';
import { getDatabase, onValue, ref } from 'firebase/database';
import { FirebaseApp } from 'firebase/app';

const useFirebaseRealtimeDatabase = <T>(key: string, app?: FirebaseApp): T | undefined => {
  const [value, setValue] = useState<T | undefined>(undefined);

  useEffect(() => {
    const db = getDatabase(app);
    const valueRef = ref(db, key);

    const unsubscribe = onValue(valueRef, (snapshot) => {
      const data = snapshot.val() as T;
      setValue(data);
    });

    return () => {
      unsubscribe();
    };
  }, [key, app]);

  return value;
};

export default useFirebaseRealtimeDatabase;
